import { Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Lottie from 'lottie-react';
import PropTypes from 'prop-types';

import emptyBox from 'assets/illustrations/emptyBox.json';

const NothingFound = ({ height, customMessage, hideBox }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid container justifyContent='center' sx={{ height: '100%', px: 2 }}>
      <Grid container direction='column' sx={{ maxWidth: theme.maxWidth / 2, mt: '5vh' }}>
        <Grid item>
          <Typography
            variant={/* istanbul ignore next */ isMobile ? 'h6' : 'h5'}
            sx={{
              textAlign: 'center',
              fontWeight: 'bold',
              color: theme.palette.customTheme.headerText,
            }}
          >
            {customMessage || 'Nothing found'}
          </Typography>
        </Grid>

        <Grid item>
          {!hideBox && (
            <Lottie
              animationData={emptyBox}
              loop={false}
              style={{
                height,
              }}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

NothingFound.propTypes = {
  height: PropTypes.string,
  customMessage: PropTypes.string,
  hideBox: PropTypes.bool,
};

NothingFound.defaultProps = {
  height: '50vh',
  customMessage: null,
  hideBox: false,
};

export default NothingFound;
